import { useState } from "react";
import { Sparkles, ArrowUpRight, X } from "lucide-react";

export default function NewsAlert() {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  return (
    <div className="relative bg-ember text-paper" data-testid="news-alert">
      <div className="container-x flex items-center justify-center gap-x-3 gap-y-1 py-2 pr-8 text-center text-[12px] md:text-[13px]">
        <span className="hidden items-center gap-1.5 rounded-full bg-black/15 px-2 py-0.5 font-mono text-[10px] uppercase tracking-overline sm:inline-flex">
          <Sparkles size={11} /> News
        </span>
        <span className="font-medium">
          Smritium is live on PyPI — we're building India's memory layer for AI.
        </span>
        <a
          href="https://pypi.org/project/upii/"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 font-mono underline underline-offset-2 transition-opacity hover:opacity-80"
          data-testid="news-alert-link"
        >
          pip install upii <ArrowUpRight size={13} />
        </a>
      </div>
      <button
        onClick={() => setOpen(false)}
        className="absolute right-3 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full transition-colors hover:bg-black/15"
        aria-label="Dismiss"
        data-testid="news-alert-close"
      >
        <X size={15} />
      </button>
    </div>
  );
}
